import { useAppSelector } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"

/**
 * Read-only drilldown asset view for a transient panel. Reads the seed live from the
 * panels slice (not props) so a refocus that updates the existing transient module's
 * drilldownSeed re-renders the panel with the new factor/category/date.
 *
 * Kept in its own module (lazy-required by the ASSET_VIEW renderer) so that
 * module-renderers — imported by non-React call sites like use-dashboard-module-actions —
 * does not statically pull in hooks/redux.
 */
export default function TransientDrilldownAssetViewPanel({ moduleId }: { moduleId: string }) {
  const dashboardId = useDashboardId()
  const drilldownSeed = useAppSelector(
    (s) => s.dashboard.panels[dashboardId]?.modules?.find((m) => m.id === moduleId)?.config?.drilldownSeed,
  )
  const frozenSnapshot = drilldownSeed?.frozenSnapshot

  if (!drilldownSeed || frozenSnapshot == null) {
    return null
  }

  const DrilldownAssetView = require("connected-components/drilldown-asset-view").default
  return <DrilldownAssetView moduleId={moduleId} seed={drilldownSeed} frozenSnapshot={frozenSnapshot} />
}
